export default __webpack_public_path__ + "static/media/review_image_1.6b8d6fe2.png";